export default {
  buckets: [],
  current: {
    loading: false,
    bookmarked: false,
    bucket: {
      name: "",
      description: "",
      kpi: "",
      advancedQuery: "",
      criteria: [{ fieldset: '', fieldName: '', condition: '', value: '' }],
      displayFields: [{ fieldset: '', fieldName: '', position: 0, sortPosition: 0, sortDirection: '' }],
      sortFields: [{ fieldset: '', fieldName: '', direction: '', position: 0 }]
    },
    bucketGroup: {
      name: "",
      buckets: [],
      hasChanged: false
    },
    caseType: {},
    headers: [],
    cases: [],
    tasklists: {},
    schema: {}
  },
  loading: false
}
